import { render, staticRenderFns } from "./AlertSuggestionsContent.vue?vue&type=template&id=0567d6c6&"
import script from "./AlertSuggestionsContent.vue?vue&type=script&lang=js&"
export * from "./AlertSuggestionsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports